import { DetectionStatus } from "../../../../utils/constants";

export const getActiveDetections = (lastDetection) => {
  if (!lastDetection) return [];
  const filteredDetection = lastDetection?.filter(
    (detection) => detection.status !== DetectionStatus.RESOLVED
  );
  return filteredDetection;
};
